<template>
  <div px-2 mb-3>
    <v-card class="widget pa-0" :class=widgetStyle>
      <widget-header :widget="metricWidget"  hideFullScreen></widget-header>
      <v-layout row class="px-4 pt-4 pb-3" :class="widgetHeight">
        <v-flex xs12 align-self-end>
          <span class="big-number" v-if="isTimebased">{{currentTimeValue}}</span>
          <span class="big-number" v-else>{{metricWidget.prefix}}{{currentValue}}{{metricWidget.suffix}}</span>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import "@/assets/styles/styles.css";
import { mapState } from "vuex";
import WidgetHeader from "@/components/metrics/WidgetHeader.vue"
import Helpers from "@/helpers.js"
import WidgetMixin from "@/components/metrics/WidgetMixin.js"
import numeral from "numeral"

export default {
  name: "NumberWidget",
  mixins: [WidgetMixin],
  components: {WidgetHeader},
  computed: {
    ...mapState({
      metrics: (state) => state.metrics.all
    }),    
    currentValue() {
      if (this.metricWidget.chartData) {
        const chartData = this.metricWidget.chartData
        const currVal = Array.isArray(chartData) ? chartData[chartData.length-1] : chartData;
        let format = this.metricWidget.scale===0 ? '0,0' : `0,0.${"".padEnd(this.metricWidget.scale, '0')}`
        if (currVal > 100000) {
          format += 'a'
        }
        return numeral(currVal).format(format)

      } else {
        return "-"
      }
    },
    currentTimeValue() {
      
      if (this.metricWidget.chartData) {
        const chartData = this.metricWidget.chartData
        const currVal = Array.isArray(chartData) ? chartData[chartData.length-1] : chartData;

        return Helpers.durationToWords(currVal)
      } else {
        return '-'
      }      
    },
  },
};
</script>